const infos = {

  // Shop-Variablen
  title: 'Mysellsy Demo',
  name: 'Mysellsy Demo',
  url: 'https://shop.mysellsy.de/',
  email: 'demo@mysellsy.de',
  //telephone: '0202/43044332',
  telephone: undefined as string | undefined,
  fax: '0202/43044350',
  publicher: 'Mysellsy Demo',
  priceRange: '$$$', // Wie Teuer sind wir?   1-5  // 1 = Billig  2 = Normal  5 = SUPER-TEUER!!!

  // SHOP INFOS
  description: 'Demo-Shop für Mysellsy. Bestellungen und Zahlungen werden nur testweise simuliert.',
  titleAlternate: 'Mysellsy Demo',
  host: 'shop.mysellsy.de',
  locale: 'de_DE',
  currency: 'EUR',

  // LEGAL INFOS
  legalowner: 'Mysellsy Demo',
  legalname: 'Mysellsy Demo',
  street: 'Alfredstr. 18',
  postalcode: '42281',
  locality: 'Wuppertal',
  region: 'Nordrhein-Westfalen',
  regionCode: 'DE-NW',
  countryCode: 'DE',

  registergericht: null as string | null, // 'Amtsgericht ???'
  registernummer: null as string | null, // 'HRB ?????'
  umsatzsteuernr: 'DE 355655005',

  // Konfiguration
  paymentAfterCheckout: false as boolean, // true = Zahlung nach Bestellung, false = Zahlung vor Bestellung
  siteId: 0,
  containerId: "",

} as const

export default infos
